import React from "react";
import { Navbar12 } from "./components/Navbar12";
import { Header84 } from "./components/Header84";
import { Layout395 } from "./components/Layout395";
import { Layout34 } from "./components/Layout34";
import { Testimonial22 } from "./components/Testimonial22";
import { Product10 } from "./components/Product10";
import { Cta31 } from "./components/Cta31";
import { Faq4 } from "./components/Faq4";
import { Cta52 } from "./components/Cta52";
import { Footer5 } from "./components/Footer5";

export default function Page() {
  return (
    <div>
      <Navbar12 />
      <Header84 />
      <Layout395 />
      <Layout34 />
      <Testimonial22 />
      <Product10 />
      <Cta31 />
      <Faq4 />
      <Cta52 />
      <Footer5 />
    </div>
  );
}
